<div class="tokens-list-header-container">
    <div class="promotional-heading">
        {{ messagesAndConfigs.promotionalTitle }}
    </div>
    @if (isAcquisitionNotificationVisible()) {
        <bs-acquisition-reward-notification
            [acquisitionRewardToken]="acquisitionRewardToken"
            (hideAcquisitionNotification)="hideAcquisitionNotification()"></bs-acquisition-reward-notification>
    }
</div>

<ng-scrollbar class="ng-scrollbar-compact" visibility="hover">
    <div class="tokens-list-container">
        @for (tokenInfo of tokenInfos; track tokenInfo.token.id) {
            <bs-reward-tokens-card
                [isRewardBannerView]="true"
                [tokenInfo]="tokenInfo"
                [isRewardDrawerEnabled]="isRewardDrawerEnabled"></bs-reward-tokens-card>
        }
    </div>
</ng-scrollbar>

<div class="banner-footer" [ngClass]="{ 'no-dismiss-link': !messagesAndConfigs.showDismissLink }">
    @if (!isRewardDrawerEnabled && messagesAndConfigs.showDismissLink) {
        <span (click)="dismissRewardBanner($event)">
            {{ messagesAndConfigs.dismissLinkText }}
        </span>
    }

    <div class="promotions-link">
        <a [href]="messagesAndConfigs.promoHubUrl" (click)="promoHubLinkClicked()"> {{ messagesAndConfigs.promoHubLinkText }}</a>
        @if (!isRewardDrawerEnabled) {
            <i class="theme-right"></i>
        }
    </div>
</div>
